import { Trans } from '@lingui/react';
import useReturningCustomerPopup from './useReturningCustomerPopup';
import useScrollToTopOnReload from './useScrollToTopOnReload';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ReturningCustomerPopup = () => {
  useScrollToTopOnReload();
  const {
    showPopup,
    handleButtonClick,
    disabledButton,
    handleClosePopup,
    manufacturer,
    content
  } = useReturningCustomerPopup();
  if (!showPopup || !content) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: "returning-customer-popup__overlay",
    onClick: handleClosePopup,
    name: "returningCustomerPopup",
    children: /*#__PURE__*/_jsxs("div", {
      className: "returning-customer-popup",
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/_jsx("button", {
        className: "returning-customer-popup__close-button",
        onClick: handleClosePopup,
        "data-tracking": true,
        "data-action": "Click",
        "data-label": "Returning Customer Popup: Close"
      }), /*#__PURE__*/_jsxs("picture", {
        className: "returning-customer-popup__image",
        children: [/*#__PURE__*/_jsx("source", {
          media: "(min-width: 768px)",
          srcSet: "//content.wirkaufendeinauto.de/static/car_images/man-sitting-in-front-of-orange-car-731x731.jpg"
        }), /*#__PURE__*/_jsx("img", {
          src: "//content.wirkaufendeinauto.de/static/car_images/man-sitting-in-front-of-orange-car-660x350.jpg",
          alt: "Man sitting in front of orange car"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "returning-customer-popup__content",
        children: [/*#__PURE__*/_jsx("h5", {
          className: "returning-customer-popup__welcome",
          children: /*#__PURE__*/_jsx(Trans, {
            id: content.welcome.id,
            message: content.welcome.message
          })
        }), /*#__PURE__*/_jsx("h3", {
          className: "returning-customer-popup__title",
          children: /*#__PURE__*/_jsx(Trans, {
            id: content.title.id,
            message: content.title.message
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "returning-customer-popup__body",
          children: /*#__PURE__*/_jsx(Trans, {
            id: content.body.id,
            message: content.body.message,
            values: {
              manufacturer: manufacturer
            },
            components: {
              0: /*#__PURE__*/_jsx("strong", {})
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "returning-customer-popup__buttons",
          children: content.buttons.map(button => /*#__PURE__*/_jsxs("button", {
            className: `returning-customer-popup__button ${button.class}`,
            onClick: () => handleButtonClick(button.action),
            "data-tracking": true,
            "data-action": "Click",
            "data-label": `Returning Customer Popup: ${button.trackingLabel}`,
            disabled: disabledButton === button.action,
            children: [disabledButton === button.action && /*#__PURE__*/_jsx("div", {
              className: `returning-customer-popup__loader ${button.loaderClass}`,
              children: /*#__PURE__*/_jsx("span", {
                className: "returning-customer-popup__loader-text",
                children: "Loading..."
              })
            }), /*#__PURE__*/_jsx("span", {
              className: "returning-customer-popup__button-text",
              children: /*#__PURE__*/_jsx(Trans, {
                id: button.id,
                message: button.message
              })
            })]
          }, button.action))
        })]
      })]
    })
  });
};
export default ReturningCustomerPopup;